import '@/utils/vconsole';
import { createApp } from 'vue';
import App from '../App.vue';
import '../css/index.less';
import i18n from '../i18n/index';

const app = createApp(App);

app.use(i18n);
app.mount('#app');
